module.exports = __webpack_public_path__ + "img/MCD_Standorte_Big_Teaser_01.06a944f8.jpg";